import { useCallback, useEffect, useState } from 'react'
import {
    DATE_FORMAT_STORAGE_KEY,
    DateFormat,
    getDateFormat,
    getTimeFormat,
    setDateFormat as persistDateFormat,
    setTimeFormat as persistTimeFormat,
    subscribeDateFormat,
    subscribeTimeFormat,
    TIME_FORMAT_STORAGE_KEY,
    TimeFormat,
} from 'utils/dateFormat'

const useDateFormat = () => {
    const [dateFormat, setDateFormatState] = useState(getDateFormat)
    const [timeFormat, setTimeFormatState] = useState(getTimeFormat)

    useEffect(() => {
        const unsubscribeDate = subscribeDateFormat(setDateFormatState)
        const unsubscribeTime = subscribeTimeFormat(setTimeFormatState)
        const onStorage = (event: StorageEvent) => {
            if (event.key === DATE_FORMAT_STORAGE_KEY) {
                setDateFormatState(getDateFormat())
            }
            if (event.key === TIME_FORMAT_STORAGE_KEY) {
                setTimeFormatState(getTimeFormat())
            }
        }
        window.addEventListener('storage', onStorage)
        return () => {
            unsubscribeDate()
            unsubscribeTime()
            window.removeEventListener('storage', onStorage)
        }
    }, [])

    const setDateFormat = useCallback((format: DateFormat) => {
        persistDateFormat(format)
    }, [])

    const setTimeFormat = useCallback((format: TimeFormat) => {
        persistTimeFormat(format)
    }, [])

    return { dateFormat, setDateFormat, timeFormat, setTimeFormat }
}

export default useDateFormat
